import {inject, Injectable, signal} from '@angular/core';
import {SearchState} from '../../../types/SearchState';
import {RoutingParamsResolveService} from './routing-params-resolve.service';
import {Params} from '@angular/router';
import {DefaultValuesService} from '../../../services/default-values.service';
import {SearchResultContent} from '../../../types/SearchResultContent';
import {ToolsService} from '../../../services/tools.service';

@Injectable()
export class LocalStateService {
  private defaults = inject(DefaultValuesService);
  public searchStateLocal = signal<SearchState>(this.defaults.getDefaultSearchState());

  constructor(
    private routingResolveService: RoutingParamsResolveService,
    private tools: ToolsService,
  ) {}

  public UpdateState(routeParams: Params, queryParams: Params, urlPath?: string): SearchState {
    this.searchStateLocal.set(this.routingResolveService.getResolvedState(routeParams, queryParams, urlPath));
    return this.searchStateLocal();
  }

  public RemoveEdgeConditionsFromSearch(searchContent: SearchResultContent, searchQueryDto?: any): boolean {
    let fallbackFilterApplied = false;
    const newSearchStateLocal = this.tools.clone(this.searchStateLocal());
    if (newSearchStateLocal.page > 1 || newSearchStateLocal.openNow || newSearchStateLocal.openWeekend) {
      newSearchStateLocal.page = 1;
      newSearchStateLocal.openNow = false;
      newSearchStateLocal.openWeekend = false;
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.timeslot != null) {
      newSearchStateLocal.timeslot = null;
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.customerFeatureType !== '') {
      newSearchStateLocal.customerFeatureType = '';
      fallbackFilterApplied = true;
    } else if (
      searchContent != null &&
      newSearchStateLocal.placeUrlPath !== '' &&
      searchContent.parentPlace != null &&
      newSearchStateLocal.placeUrlPath !== searchContent.parentPlace
    ) {
      const placeWeHaveDataFrom: string = this.getPlaceFromSearchQueryDto(searchQueryDto);
      if (placeWeHaveDataFrom !== '' && placeWeHaveDataFrom !== searchContent.parentPlace) {
        newSearchStateLocal.placeUrlPath = searchContent.parentPlace;
      } else {
        newSearchStateLocal.placeUrlPath = '';
      }
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.locationSearch === true) {
      newSearchStateLocal.locationSearch = false;
      newSearchStateLocal.lat = 0;
      newSearchStateLocal.lon = 0;
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.placeUrlPath !== '') {
      newSearchStateLocal.placeUrlPath = '';
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.symptomUrlPath !== '') {
      newSearchStateLocal.symptomUrlPath = '';
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.careServiceTypeUrlPath !== '') {
      newSearchStateLocal.careServiceTypeUrlPath = '';
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.caregiverUnitTypeUrlPath !== '') {
      newSearchStateLocal.caregiverUnitTypeUrlPath = '';
      fallbackFilterApplied = true;
    } else if (newSearchStateLocal.freeSearchTerm !== '') {
      newSearchStateLocal.freeSearchTerm = '';
      fallbackFilterApplied = true;
    }
    if (fallbackFilterApplied) {
      this.searchStateLocal.set(newSearchStateLocal);
    }
    return fallbackFilterApplied;
  }

  private getPlaceFromSearchQueryDto(searchQueryDto: any): string {
    let place: string = '';
    if (searchQueryDto != null && searchQueryDto.must != null && searchQueryDto.must.length > 0) {
      const mustItem = searchQueryDto.must.find((item) => item.field === 'places.urlPath');
      if (mustItem != null) {
        place = mustItem.value;
      }
    }
    return place;
  }
}
